<template>
    <div>
        <div class="container">
            <div class="col-md-6 offset-md-3 text-center">
                <div class="wrap-block6">
                    <img src="@/assets/img/final.png" class="element-final img-fluid">
                    <h1>Bedankt voor het invullen!</h1>
                </div>
            </div>
            <div class="col-md-8 offset-md-2 text-center ">
                <div class="wrap-block6">
                    <p>
                        Je ontvangt nu snel (1) informatie over de doelgroep, (2) de door jou gegeven input voor de
                        vacature en (3) een advies welke media je het beste kunt inzetten om jouw doelgroep te bereiken.
                        Als je ook voor een wervende vacaturetekst hebt gekozen, ontvang je die binnen drie werkdagen.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import store from '../store'

  export default {
    name: 'QuestionListComplete',
    mounted: function () {
      store.commit('question/clearState')
    },
    computed: mapGetters({
      totalSteps: 'question/getTotalSteps',
    }),
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    h1, h2 {
        font-weight: normal;
        margin-bottom: 15px;
    }

    p, li {
        font-weight: 300;
        font-size: 1.4rem;
    }

    ul {
        display: block;

        li {
            margin-bottom: 5px;
            display: list-item;

            .fa {
                font-size: 0.5rem;
                position: absolute;
                margin-left: -15px;
                margin-top: 14px;
            }
        }
    }

    a {
        color: #35495E;
    }

    .element-final {
        width: 30%;
        margin-top: 90px;
        margin-bottom: 36px;
    }
</style>
